// @flow

import Immutable from 'immutable';
import * as actionTypes from './action-types';
import type { PrivateState, PublicState, Action } from '../../types';

const privateState = ({
  zoom: 0,
  width: 0,
  height: 0,
  tileJSON: undefined,
  bounds: undefined,
}: PrivateState);

const publicState = ({
  debug: false,
  url: '',
  listings: [],
  favorites: [],
  selected: undefined,
  onListingClick: undefined,
  onListingsHover: undefined,
  className: undefined,
  style: undefined,
}: PublicState);

const MapState = Immutable.Record({
  ...privateState,
  ...publicState,
});

const MapAPI = Immutable.Record(publicState);
const mergeProps = (state, props: PublicState) => state.merge(new MapAPI(props));

export const defaultState = (props: PublicState) => mergeProps(new MapState(), props);

export default (state: MapState = new MapState(), { payload, type }: Action) => {
  switch (type) {
    case actionTypes.UPDATE_DIMENSIONS: {
      const {
        width = window.innerWidth,
        height = window.innerHeight,
      } = payload;

      return state.merge({ width, height });
    }
    case actionTypes.UPDATE_VIEWPORT:
      return state.merge(payload);
    case actionTypes.UPDATE_API_PROPS:
      return mergeProps(state, payload);
    case actionTypes.UPDATE_TILE_JSON:
      return state.merge({ tileJSON: payload, bounds: null });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/map/reducer.js